const actions = {
  async setTwoFAEmail({ commit, getters }, email) {
      commit('updateTwoFAEmail',  email );
    }, 
    
    async setIsNewRegistration({ commit, getters }, isNewRegistration) {
      commit('updateIsNewRegistration',  isNewRegistration );
    } ,

    async setNewUserpassword({ commit, getters }, newUserpassword) {
      commit('updateNewUserpassword',  newUserpassword );
    } ,
    async setIsUserInactive({ commit, getters }, isUserInactive) {
      commit('updateIsUserInactive',  isUserInactive );
    } 
};

export { actions };